<template>
  <div class="navigation-drawer" :class="{ open: open }">
    <transition name="fade">
      <div v-show="open" class="navigation-drawer-overlay" @touchend="onTouchend"></div>
    </transition>
    <transition name="slide-left">
      <div v-show="open" v-click-outside="hide" class="navigation-drawer-content">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>
<script>
import ClickOutside from '@/pixel/utils/ClickOutside';

export default {
  components: {},

  directives: {
    ClickOutside,
  },

  props: ['open'],

  data() {
    return {
      openTimeout: false,
    };
  },

  computed: {},

  watch: {
    open(isOpen) {
      if (isOpen) {
        this.openTimeout = true;
        setTimeout(() => {
          this.openTimeout = false;
        }, 200);
      }
    },
  },

  methods: {
    hide() {
      if (this.open && !this.openTimeout) {
        this.$emit('hide');
      }
    },

    onTouchend() {
      this.$emit('hide');
    },
  },
};
</script>
<style lang="postcss">
@import '@/pixel/style/variables';

.navigation-drawer {
  .navigation-drawer-overlay {
    z-index: 100;
    position: fixed;
    width: 100%;
    min-height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: white;
    opacity: 0.7;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .navigation-drawer-content {
    z-index: 101;
    position: fixed;
    right: 0;
    top: 0;
    height: 100%;
    overflow: scroll;
    width: 260px;
    transform: translate(0px, 0px);
    background-color: var(--white);
    box-shadow: 0 var(--box-shadow-blur) var(--box-shadow-spread) rgba(0, 0, 0, 0.2);
  }

  .fade-enter-active {
    transition: opacity 250ms ease-out;
  }
  .fade-leave-active {
    transition: opacity 250ms ease-out;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }

  .slide-left-enter-active {
    transition: transform 250ms ease-out;
  }
  .slide-left-leave-active {
    transition: transform 250ms ease-out;
  }
  .slide-left-enter-from,
  .slide-left-leave-to {
    transform: translate(300px, 0px);
  }
}
</style>
